import { OrbitControls, useGLTF, Html } from '@react-three/drei';
import { DirectionalLightHelper } from 'three';
import { Suspense, useEffect, useRef } from 'react';
import { useProgress, Environment, Text } from '@react-three/drei';
import { useControls } from 'leva';
import { useThree, useFrame } from '@react-three/fiber'
import { useNavigate } from 'react-router-dom';
import TeleportDisk from './TeleportDisk';

const MODEL_URL = '/assets/hall/hall.glb';

useGLTF.preload(MODEL_URL);

function Loader() {
  const { progress } = useProgress();
  return (
    <Html center>
        <div style={{ fontSize: '1.5rem', color: '#333' }}>
            Chargement : {Math.floor(progress)}%
        </div>
    </Html>
  );
}

function Scene() {
    const gltf = useGLTF(MODEL_URL);

    const { position, rotation, scale } = useControls('Modèle', {
        position: { value: [0.8, -1, 4], step: 0.1 },
        rotation: { value: [0, 3.15, 0], step: 0.01 },
        scale: { value: 1, min: 0.01, max: 10 },
    });

    return (
        <primitive
            object={gltf.scene}
            position={position}
            rotation={rotation}
            scale={scale}
        />
    );
}

function CameraControls() {
    const { camera } = useThree();

    const { camX, camY, camZ, fov } = useControls('Caméra', {
        camX: { value: 0.11, min: -20, max: 20, step: 0.01 },
        camY: { value: 2.26, min: -20, max: 20, step: 0.01 },
        camZ: { value: 8.6, min: -20, max: 20, step: 0.01 },
        fov: { value: 45, min: 10, max: 120, step: 1 },
    });

    useEffect(() => {
        camera.position.set(camX, camY, camZ);
        camera.fov = fov;
        camera.updateProjectionMatrix();
    }, [camX, camY, camZ, fov, camera]);

    return null;
}

export default function Experience() {
    const navigate = useNavigate();

    const { intensity, lightX, lightY, lightZ } = useControls('Lumière', {
        intensity: { value: 1, min: 0, max: 5, step: 0.1 },
        lightX: { value: 5, min: -10, max: 10 },
        lightY: { value: 10, min: -10, max: 20 },
        lightZ: { value: 5, min: -10, max: 10 },
    });

    return (
        <>
            Site fermé
        </>
    );
}
